import { apiGet, apiPatch, apiPost } from 'shared/services/api/resource';
import { MOCK_SUBSCRIPTIONS } from 'modules/arena/subscriptions/content';
import { StudentSubscription, SubscriptionStatus } from 'modules/arena/subscriptions/types';

export function fetchSubscriptions(): Promise<StudentSubscription[]> {
  return apiGet(MOCK_SUBSCRIPTIONS, '/arena/subscriptions');
}

export function updateSubscriptionStatus(id: string, status: SubscriptionStatus) {
  return apiPatch({ id, status }, `/arena/subscriptions/${id}`, { status });
}

export function chargeSubscriptionNow(id: string) {
  return apiPost({ id, status: 'ativa' as SubscriptionStatus }, `/arena/subscriptions/${id}/charge`, undefined, 300);
}
